import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Coa2 from "../../../containers/modules/accounting/coa2";

export default function Coa2Route(props) {
  const { authUser } = props;
  return (
    <Route
      path="coa2"
      index
      element={
        <AccessControl
          name={"Coa2 List"}
          auth={authUser}
          component={() => <Coa2 />}
        />
      }
    />
  );
}
